import * as THREE from 'three';

export const getCircleShaderMaterial = (texture, radius, planeWidth, planeHeight) => {
  return new THREE.ShaderMaterial({
    uniforms: {
      uTexture: { value: texture },
      uRadius: { value: radius },
      uPlaneWidth: { value: planeWidth }, // default value, adjust accordingly
      uPlaneHeight: { value: planeHeight },
    },
    vertexShader: `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
    fragmentShader: `
    uniform sampler2D uTexture;
    uniform float uRadius;
    uniform float uPlaneWidth;
    uniform float uPlaneHeight;
    varying vec2 vUv;
    void main() {
        vec2 aspectCorrectedUV = uPlaneHeight < uPlaneWidth ? 
                         vec2(vUv.x * uPlaneWidth / uPlaneHeight, vUv.y) :
                         vec2(vUv.x, vUv.y * uPlaneHeight / uPlaneWidth);
        float dist = distance(aspectCorrectedUV, vec2(0.5 * uPlaneWidth, 0.5 * uPlaneHeight));
        if (dist > uRadius) discard;

        gl_FragColor = texture2D(uTexture, vUv);
    }
`,
    transparent: true,
  });
};
